module.exports = __webpack_public_path__ + "img/icons8-checked.a1833288.svg";